<div class="container-fluid mt-4">
  <form novalidate [formGroup]="wellPadForm">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="projectWellCount">Project Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="projectWellCount" type="text" class=" k-textbox form-control" formControlName="ProjectWellCount" readonly>
        </div>
      </div>
      <div class="col-md-8">
        <button type="button" style="float: right;" kendoButton themeColor="primary" [svgIcon]="icons.refresh" [buttonLoading]="loading" [disabled]="loading" (click)="getWellPadParameters(true)">Refresh Parameters</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="espWellCount">ESP Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="espWellCount" type="text" class=" k-textbox form-control" formControlName="ESPWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="gasLiftWellCount">Gas Lift Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="gasLiftWellCount" type="text" class=" k-textbox form-control" formControlName="GasLiftWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="hpglWellCount">HPGL Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="hpglWellCount" type="text" class=" k-textbox form-control" formControlName="HPGLWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="esp7WellCount">ESP-7 Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="esp7WellCount" type="text" class=" k-textbox form-control" formControlName="ESP7WellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="esphrWellCount">ESP-HR Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="esphrWellCount" type="text" class=" k-textbox form-control" formControlName="ESPHRWellCount" readonly>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="dualFlowWellCount">Dual Flow Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="dualFlowWellCount" type="text" class=" k-textbox form-control" formControlName="DualFlowWellCount" readonly>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="aboveGradeWellCount">Above Grade Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="aboveGradeWellCount" type="number" class=" k-textbox form-control" formControlName="AboveGradeWellCount" readonly>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="belowGradeWellCount">Below Grade Well Count</label>
          <!--TODO move the 'readonly' logic to the reactive form instead of here in the markup-->
          <input id="belowGradeWellCount" type="number" class=" k-textbox form-control" formControlName="BelowGradeWellCount" readonly>
        </div>
      </div>
    </div>

    <hr />
    <br />

    @if (wellTesterError!='') {
    <div class="row alert alert-warning">
      <div class="col-md-12">
        <h4>{{wellTesterError}}</h4>
      </div>
    </div>
    }

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="testerPermanent">Permanent Well Testers</label>
          <input id="testerPermanent" type="number" class=" k-textbox form-control" formControlName="Tester_Permanent">
        </div>
      </div>
      <!-- <div class="col-md-4">
      <div class="form-group">
        <label>Temporary Well Testers</label>
        <input type="number" class=" k-textbox form-control" formControlName="Tester_Temporary">
      </div>
    </div> -->
      <div class="col-md-4">
        <div class="form-group">
          <label for="testerMpfMeter">Multi Phase Flow Meters</label>
          <input id="testerMpfMeter" type="number" class=" k-textbox form-control" formControlName="Tester_MPFMeter">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Pad Visit Type</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="dCellarPadVisitTypes"
            [textField]="'Description'" formControlName="CellarPadVisitTypeId" [valueField]="'CellarPadVisitTypeId'"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Tank Battery Design</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="dTankBatteryDesigns"
            [textField]="'Description'" formControlName="AssociatedTankBatteryDesignId" [valueField]="'TankBatteryDesignId'"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Located on Tank Battery Pad</label>
          <kendo-dropdownlist class="form-control" [style.width.%]="100" [data]="yesNoResponse"
            [textField]="'text'" formControlName="IsLocatedOnTankBatteryPad" [valueField]="'value'"
            [valuePrimitive]="true">
          </kendo-dropdownlist>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="wellToEdgeOfPadDistance">Well to Edge of Pad Distance(ft)</label>
          <input id="wellToEdgeOfPadDistance" type="number" class=" k-textbox form-control" formControlName="WellToEdgeOfPadDistance">
        </div>
      </div>
    </div>
  </form>
</div>